import { post, put } from '.';

export const getNotifications = ({ filters }) => post('notifications', filters);

export const markAsRead = ({ notificationId }) =>
  put(`notifications/${notificationId}/read`);
